<dx-popup
  [title]="theme.id? 'Update Theme' : 'Create Theme'"
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  contentTemplate="popup-content">
  <div *dxTemplate="let data of 'popup-content'">
    <form (submit)="send($event)">
      <dx-form [formData]="_theme" >

                <dxi-item dataField="name" [isRequired]="true">
                    <dxi-validation-rule
                            type="pattern"
                            pattern="^[a-zA-Z0-9\s-]+$"
                            message="Invalid. Name must contain letters, numbers and spaces.">
                    </dxi-validation-rule>
                </dxi-item>

                <dxi-item dataField="report type" [isRequired]="true">
                    <dx-select-box
                            [items]="reportTypes"
                            [value]="_theme.type"
                            (onValueChanged)="selectType($event)">
                    </dx-select-box>
                </dxi-item>
                <dxi-item dataField="tenant" [isRequired]="true">
                  <dx-tag-box
                          [items]="tenants"
                          [value]="_theme.tenant"
                          displayExpr="displayName"
                          valueExpr="value"
                          (onValueChanged)="onTenantChange($event)">
                  </dx-tag-box>
                </dxi-item>

                <dxi-item dataField="description"></dxi-item>
                <dxi-item itemType="group" colCount="1">

                    <!-- Chart Palette -->
                    <dxi-item itemType="group">
                        <dxi-item caption="Chart Palette*" itemType="group">
                            <dxi-item>
                                <div *dxTemplate class="row flex-wrap">
                                    @if(_theme?.chartPalette?.colors) {
                                        @for(color of _theme.chartPalette.colors; track $index) {
                                            <div class="column align-center chart-element">
                                                <div class="color-result-preview"
                                                     [ngStyle]="{'background-color': 'rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'}">
                                                </div>
                                                {{ colorToHex(color) }}
                                                <dx-button icon="remove" (onClick)="removeChartPalette($index)"></dx-button>
                                            </div>
                                        }
                                    }
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group">
                            <dxi-item>
                                <div *dxTemplate class="row">
                                    <div>
                                        <span class="invalid">{{ errorMessages.chartColor }}</span>
                                        <dx-color-box
                                                label="Color"
                                                (onValueChanged)="addNewChartPalette($event)"
                                                [(value)]="chartColorValue">
                                        </dx-color-box>
                                    </div>
                                </div>
                            </dxi-item>
                        </dxi-item>

                        @if((_theme?.chartPalette?.colors?.length ?? 0) < 10) {
                            <dxi-item class="invalid">
                                Please add at least 10 colors.
                            </dxi-item>
                        }
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" cssClass="file-section">
                    <dxi-item>
                        <div *dxTemplate>
                            <table class="file-table">
                                <tr>
                                    <td>
                                        <dx-file-uploader
                                                class="inline-uploader"
                                                selectButtonText="Upload a file"
                                                readyToUploadMessage=""
                                                [labelText]="''"
                                                uploadMode="useForm"
                                                [(value)]="files"
                                                [allowedFileExtensions]="['.indd']"
                                                [showFileList]="false"
                                                [multiple]="false">
                                        </dx-file-uploader>
                                    </td>
                                </tr>
                                @if(files?.length) {
                                    <tr>
                                        <td>
                                            <a class="download-link" [title]="files[0].name">
                                                {{ files[0].name }}
                                            </a>
                                        </td>
                                    </tr>
                                } @else if(theme.fileName) {
                                    <tr>
                                        <td>
                                            <a class="download-link" (click)="downloadFile()" title="Download {{ theme.fileName }}">
                                                {{ theme.fileName }}
                                            </a>
                                        </td>
                                    </tr>
                                }
                                @if(_theme?.id && _theme?.idsFileId) {
                                    <tr>
                                        <td colspan="2">
                                            <div class="preview-pages-section">
                                                <div class="preview-pages-header">
                                                    <span class="preview-pages-title">Preview Pages</span>
                                                    <dx-button
                                                        icon="plus"
                                                        hint="Add preview page"
                                                        (onClick)="openAddPreviewPageDialog()">
                                                    </dx-button>
                                                </div>
                                                @if(_theme?.previewPages?.length) {
                                                    <div class="preview-pages-carousel highlighted-row"
                                                         (dragover)="onDragOver($event)"
                                                         (drop)="onDrop($event)">
                                                        @for(page of _theme.previewPages.slice(0, 5); track page.previewId; let i = $index) {
                                                            <div class="preview-page-item highlighted"
                                                                 [attr.data-page-id]="page.previewId"
                                                                 [attr.data-index]="i"
                                                                 draggable="true"
                                                                 (dragstart)="onDragStart($event, i)"
                                                                 (dragend)="onDragEnd($event)"
                                                                 (dragover)="onDragOverItem($event, i)"
                                                                 [class.dragging]="draggedIndex === i">
                                                                <div class="preview-page-thumbnail"
                                                                     (click)="openPreviewPage(page.previewId, page.name)"
                                                                     title="View page">
                                                                    <img [src]="getPreviewPageUrl(page.previewId)" 
                                                                         alt="{{page.name}}" />
                                                                    <div class="preview-page-overlay">
                                                                        <span class="page-number">{{i + 1}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="preview-page-name" [title]="page.name">
                                                                    {{page.name}}
                                                                </div>
                                                                <div class="preview-page-actions">
                                                                    <dx-button
                                                                        icon="download"
                                                                        hint="Download page"
                                                                        (onClick)="downloadPreviewPage(page.previewId, page.name, $event)">
                                                                    </dx-button>
                                                                    <dx-button
                                                                        icon="trash"
                                                                        hint="Delete page"
                                                                        (onClick)="deletePreviewPage(page.previewId, $event)">
                                                                    </dx-button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    @if(_theme.previewPages.length > 5) {
                                                        <div class="preview-pages-carousel"
                                                             (dragover)="onDragOver($event)"
                                                             (drop)="onDrop($event)">
                                                            @for(page of _theme.previewPages.slice(5); track page.previewId; let i = $index) {
                                                                <div class="preview-page-item secondary"
                                                                     [attr.data-page-id]="page.previewId"
                                                                     [attr.data-index]="i + 5"
                                                                     draggable="true"
                                                                     (dragstart)="onDragStart($event, i + 5)"
                                                                     (dragend)="onDragEnd($event)"
                                                                     (dragover)="onDragOverItem($event, i + 5)"
                                                                     [class.dragging]="draggedIndex === i + 5">
                                                                    <div class="preview-page-thumbnail"
                                                                         (click)="openPreviewPage(page.previewId, page.name)"
                                                                         title="View page">
                                                                        <img [src]="getPreviewPageUrl(page.previewId)" 
                                                                             alt="{{page.name}}" />
                                                                        <div class="preview-page-overlay">
                                                                            <span class="page-number">{{i + 6}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="preview-page-name" [title]="page.name">
                                                                        {{page.name}}
                                                                    </div>
                                                                    <div class="preview-page-actions">
                                                                        <dx-button
                                                                            icon="download"
                                                                            hint="Download page"
                                                                            (onClick)="downloadPreviewPage(page.previewId, page.name, $event)">
                                                                        </dx-button>
                                                                        <dx-button
                                                                            icon="trash"
                                                                            hint="Delete page"
                                                                            (onClick)="deletePreviewPage(page.previewId, $event)">
                                                                        </dx-button>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                } @else {
                                                    <div class="no-preview-pages">
                                                        No preview pages. Click + to add.
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </table>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item>
                    <div *dxTemplate class="indicator">
                        <dx-load-indicator [visible]="showIndicator"></dx-load-indicator>
                    </div>
                </dxi-item>

                <dxi-item itemType="button"
                          [buttonOptions]="{ useSubmitBehavior: true, text: 'Save', icon: 'save' }">
                </dxi-item>

            </dx-form>
        </form>
    </div>
</dx-popup>

<dx-popup
    [title]="enlargedPreviewPageName || 'Preview Page'"
    [(visible)]="previewPagePopupVisible"
    [showCloseButton]="true"
    [width]="'auto'"
    [height]="'90%'"
    [maxWidth]="'90%'"
    (onHiding)="closePreviewPagePopup()"
    [wrapperAttr]="{ class: 'preview-page-popup' }"
    contentTemplate="previewPageContent">
    <div *dxTemplate="let data of 'previewPageContent'" class="preview-page-popup-container">
        <img [src]="enlargedPreviewPageUrl" class="preview-page-enlarged" />
    </div>
</dx-popup>

<dx-popup
    title="Add Preview Page"
    [(visible)]="addPreviewPageDialogVisible"
    [showCloseButton]="true"
    [width]="400"
    [height]="'auto'"
    (onHiding)="closeAddPreviewPageDialog()">
    <div class="add-preview-page-dialog">
        <div class="dialog-field">
            <label>Page Name <span class="required">*</span></label>
            <dx-text-box
                [(value)]="newPreviewPageName"
                placeholder="Enter unique page name"
                (onValueChanged)="validatePreviewPageName()">
            </dx-text-box>
            @if(previewPageNameError) {
                <div class="field-error">{{previewPageNameError}}</div>
            }
        </div>
        <div class="dialog-field">
            <label>PNG File <span class="required">*</span></label>
            <input
                type="file"
                accept=".png"
                #addPreviewPageInput
                style="display: none"
                (change)="onNewPreviewPageFileSelected($event)"/>
            <div class="file-select-row">
                <dx-button
                    text="Select File"
                    icon="folder"
                    (onClick)="addPreviewPageInput.click()">
                </dx-button>
                <span class="selected-file-name">{{newPreviewPageFile?.name || 'No file selected'}}</span>
            </div>
        </div>
        <div class="dialog-actions">
            <dx-button
                text="Cancel"
                (onClick)="closeAddPreviewPageDialog()">
            </dx-button>
            <dx-button
                text="Add"
                type="default"
                [disabled]="!canAddPreviewPage"
                (onClick)="addPreviewPage()">
            </dx-button>
        </div>
    </div>
</dx-popup>
